
const atmosphereMaskApply = () => import('../views/atmosphere-mask/apply')
const atmosphereMaskConfirm = () => import('../views/atmosphere-mask/confirm')
const atmosphereMaskNotice = () => import('../views/atmosphere-mask/notice')
const atmosphereMaskIndex = () => import('../views/atmosphere-mask/index')
const atmosphereMaskReserv = () => import('../views/atmosphere-mask/reserv')
const atmosphereMaskShare = () => import('../views/atmosphere-mask/share')
const atmosphereMaskReservComp = () => import('../views/atmosphere-mask/complete')
const atmosphereMaskShareComp = () => import('../views/atmosphere-mask/shareComplete')
// import atmosphereMask from './atmosphereMask.js'

export default [
    {
      path: '/old/atmosphere-mask-apply',
      name: 'atmosphere-mask-apply',
      component: atmosphereMaskApply
    },
    {
      path: '/old/atmosphere-mask-confirm',
      name: 'atmosphere-mask-confirm',
      component: atmosphereMaskConfirm
    },
    {
      path: '/old/atmosphere-mask-notice',
      name: 'atmosphere-mask-notice',
      component: atmosphereMaskNotice
    },
    {
      path: '/old/atmosphere-mask-index',
      name: 'atmosphere-mask-index',
      component: atmosphereMaskIndex
    },
    {
      path: '/old/atmosphere-mask-reservations',
      name: 'atmosphere-mask-reservations',
      component: atmosphereMaskReserv
    },
    {
      path: '/old/atmosphere-mask-share',
      name: 'atmosphere-mask-share',
      component: atmosphereMaskShare
    },
    {
      path: '/old/atmosphere-mask-reservations-complete/:reservation',
      name: 'atmosphere-mask-reservations-complete',
      component: atmosphereMaskReservComp
    },
    {
      path: '/old/atmosphere-mask-share-complete/:reservation',
      name: 'atmosphere-mask-share-complete',
      component: atmosphereMaskShareComp
    },
  ]